import { TableSharedCssClassName } from '@atlaskit/editor-common/styles';
import { findDomRefAtPos, findParentNodeClosestToPos } from '@atlaskit/editor-prosemirror/utils';

// Calculate offset top for decorationBottom positioning
export const getDecorationBottom = (modalDecorationElement, targetWrapper) => {
  let decorationBottom = modalDecorationElement.offsetTop;
  let tempOffsetParent = modalDecorationElement.offsetParent;
  if (!targetWrapper || !tempOffsetParent) {
    return decorationBottom + modalDecorationElement.offsetHeight;
  }
  while (tempOffsetParent !== targetWrapper) {
    if (!tempOffsetParent.classList.contains('fabric-editor-popup-scroll-parent')) {
      decorationBottom = decorationBottom + tempOffsetParent.offsetTop;
    }
    tempOffsetParent = tempOffsetParent.offsetParent;
  }
  return decorationBottom + modalDecorationElement.offsetHeight;
};

/**
 * Gets wrapper of the nearest resizable element or the
 * wrapper of the nearest breakout element looking up from the given position
 * this wrapper is to be used as a reference point for ai modal positioning
 */
export function getResizableOrBreakoutWrapper(editorView, position) {
  let resolvedPos = editorView.state.doc.resolve(position);
  const {
    nodes,
    marks
  } = editorView.state.schema;
  const domAtPos = editorView.domAtPos.bind(editorView);

  /**
   * At the moment, the table node is the only resizable node
   * which can trigger the AI modal.
   */
  const resizableNode = findParentNodeClosestToPos(resolvedPos, currentNode => currentNode.type === nodes.table);
  if (resizableNode) {
    const resizableDomNode = findDomRefAtPos(resizableNode.start, domAtPos);
    if (resizableDomNode) {
      /**
       * At the moment this only resizable tables need to be handled
       * hence why we use the table resizer class name specifically.
       */
      const resizableWrapper = resizableDomNode.closest(`.${TableSharedCssClassName.TABLE_RESIZER_CONTAINER}`);
      if (resizableWrapper) {
        return resizableWrapper;
      }
    }
  }
  const nodeWithBreakout = findParentNodeClosestToPos(resolvedPos, currentNode => {
    return currentNode.type === nodes.table && currentNode.attrs.layout !== 'default' || currentNode.marks.some(mark => mark.type === marks.breakout);
  });
  if (!nodeWithBreakout) {
    return;
  }
  const domNodeWithBreakout = findDomRefAtPos(nodeWithBreakout.start, domAtPos);
  if (!domNodeWithBreakout) {
    return;
  }
  if ([nodes.layoutSection, nodes.expand].includes(nodeWithBreakout.node.type)) {
    return domNodeWithBreakout.parentElement || undefined;
  }
  if (nodeWithBreakout.node.type === nodes.table) {
    return domNodeWithBreakout.closest(`.${TableSharedCssClassName.TABLE_CONTAINER}`) || undefined;
  }
}